<template>
  <div class="leavehospitaldetail">
    <el-row style="height:54px;line-height:54px;">
      <el-col :span="2">
        <kt-button :label="leaveHospital.back" type="primary" @click="handleBack" />
      </el-col>
      <el-col :span="2" :offset="8" style="font-size:18px;color:#3A77E2;">{{leaveHospital.dischargeNotice}}</el-col>
    </el-row>
    <el-row ref="print">
      <el-row class="borderMargintop">
        <el-row class="heightBackground">
          <el-col style="font-size:18px;">
            <img
              src="@/assets/beadhouse/juxing.png"
              alt
              style="vertical-align:middle;margin:0 10px;"
            />
            <span>{{leaveHospital.baseInfo}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-form label-width="100px" label-position="right" style="width:90%;margin:0 auto;color:#6f7075">
            <el-row>
              <el-col :span="8" :offset="4">
                <el-form-item label="老人姓名:" class="marginTop25">
                  <div class="height40">{{basicInformation.oldmanName}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8" :offset="4">
                <el-form-item label="性别:" class="marginTop25">
                  <div class="height40">{{basicInformation.sex}}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" :offset="4">
                <el-form-item label="身份证号:" class="marginTop25">
                  <div class="height40">{{basicInformation.idCard}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8" :offset="4">
                <el-form-item label="床位号:" class="marginTop25">
                  <div class="height40">{{basicInformation.bedNo}}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8" :offset="4">
                <el-form-item label="出生日期:" class="marginTop25">
                  <div class="height40">{{basicInformation.birthday}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8" :offset="4">
                <el-form-item label="入住日期:" class="marginTop25">
                  <div class="height40">{{basicInformation.inDate}}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-row>
      </el-row>
      <el-row class="borderMargintop">
        <el-row class="heightBackground">
          <el-col style="font-size:18px;">
            <img
              src="@/assets/beadhouse/juxing.png"
              alt
              style="vertical-align:middle;margin:0 10px;"
            />
            <span>出院时间</span>
          </el-col>
        </el-row>
        <el-row>
          <el-form label-width="100px" label-position="right" style="width:90%;margin:0 auto;color:#6f7075">
            <el-row>
              <el-col :span="8" :offset="4">
                <el-form-item label="出院时间:" class="marginTop25">
                  <div class="height40">{{leaveTime.leaveDate}}</div>
                </el-form-item>
              </el-col>
              <el-col :span="8" :offset="4">
                <el-form-item label="原因:" class="marginTop25">
                  <div class="height40">{{leaveTime.type}}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-row>
      </el-row>
      <el-row class="borderMargintop" v-if="shouldPayList.length>0">
        <el-row class="heightBackground">
          <el-col style="font-size:18px;">
            <img
              src="@/assets/beadhouse/juxing.png"
              alt
              style="vertical-align:middle;margin:0 10px;"
            />
            <span>应缴项</span>
          </el-col>
        </el-row>
        <el-row style="width:100%;">
          <table class="table">
            <thead>
              <tr class="tr">
                <th class="th1" rowspan="2">应缴项</th>
                <th class="th1" rowspan="2">缴费金额</th>
              </tr>
            </thead>
            <tbody>
              <tr class="tr" v-for="(item,index) in shouldPayList" :key="index">
                <td class="td1">{{item.itemName}}</td>
                <td class="td1">{{item.totalFee}}</td>
              </tr>
            </tbody>
          </table>
        </el-row>
      </el-row>
      <el-row class="borderMargintop">
        <el-row class="heightBackground">
          <el-col style="font-size:18px;">
            <img
              src="@/assets/beadhouse/juxing.png"
              alt
              style="vertical-align:middle;margin:0 10px;"
            />
            <span>退款项</span>
          </el-col>
        </el-row>
        <el-row>
          <table class="table">
            <thead>
              <tr class="tr">
                <th class="th1" rowspan="2">退款项</th>
                <th class="th1" rowspan="2">退款金额</th>
              </tr>
            </thead>
            <tbody>
              <tr class="tr" v-for="(item,index) in refundItemList" :key="index">
                <td class="td1">{{item.itemName}}</td>
                <td class="td1">{{item.totalFee}}</td>
              </tr>
            </tbody>
          </table>
          <!-- 套餐存在才显示表格，否则就隐藏表格 -->
          <table v-if="setMealList.length>0" class="table" style="margin-top:20px;">
            <thead>
              <tr class="tr">
                <th class="th2" rowspan="2">退费套餐名称</th>
                <th class="th2" rowspan="2">退款套餐项目</th>
                <th class="th2" rowspan="2">套餐剩余周期数</th>
                <th class="th2" rowspan="2">套餐退费标准</th>
                <th class="th2" rowspan="2">退款金额</th>
              </tr>
            </thead>
            <tbody>
              <tr class="tr" v-for="(item,index) in setMealList" :key="index">
                <td class="td2" v-if="index==0" :rowspan="setMealList.length">{{item.setMealName}}</td>
                <td class="td2">{{item.itemName}}</td>
                <td class="td2">{{item.residueDegree}}</td>
                <td class="td2">{{item.returnStandard}}</td>
                <td class="td2">{{item.itemTotalFee}}</td>
              </tr>
            </tbody>
          </table>
          <!-- 套餐存在才显示，否则就隐藏 -->
          <el-row v-if="setMealList.length>0" style="height:70px;line-height:70px;text-align:center;color:#6f7075;">
            <el-col :span="12" class="borderRight">退费合计</el-col>
            <el-col :span="12" class="borderRight">{{setMealTotal}}</el-col>
          </el-row>
        </el-row>
      </el-row>
      <el-row class="borderMargintop">
        <el-row class="heightBackground">
          <el-col style="font-size:18px;">
            <img
              src="@/assets/beadhouse/juxing.png"
              alt
              style="vertical-align:middle;margin:0 10px;"
            />
            <span>天数退费</span>
          </el-col>
        </el-row>
        <el-row
          v-if="false"
          style="height:70px;line-height:70px;text-align:center;color:#6f7075;border-bottom:1px #F1EFF2 solid;"
        >
          <el-col :span="6" class="borderRight">入院月剩余天数合计</el-col>
          <el-col :span="6" class="borderRight">{{onAdmissionRefund.days}}</el-col>
          <el-col :span="6" class="borderRight">入院月剩余天数应缴合计</el-col>
          <el-col :span="6" class="borderRight">{{onAdmissionRefund.totalFee}}</el-col>
        </el-row>
        <el-row
          style="height:70px;line-height:70px;text-align:center;color:#6f7075;border-bottom:1px #F1EFF2 solid;"
        >
          <el-col :span="6" class="borderRight">请假天数合计</el-col>
          <el-col :span="6" class="borderRight">{{LeaveRestRefund.days}}</el-col>
          <el-col :span="6" class="borderRight">请假天数退费合计</el-col>
          <el-col :span="6" class="borderRight">{{LeaveRestRefund.totalFee}}</el-col>
        </el-row>
        <el-row style="height:70px;line-height:70px;text-align:center;color:#6f7075;">
          <el-col :span="6" class="borderRight">本月剩余天数合计</el-col>
          <el-col :span="6" class="borderRight">{{thisMonthRestRefund.days}}</el-col>
          <el-col :span="6" class="borderRight">本月剩余天数退费合计</el-col>
          <el-col :span="6" class="borderRight">{{thisMonthRestRefund.totalFee}}</el-col>
        </el-row>
      </el-row>
      <el-row class="borderMargintop">
        <el-row class="heightBackground">
          <el-col style="font-size:18px;">
            <img
              src="@/assets/beadhouse/juxing.png"
              alt
              style="vertical-align:middle;margin:0 10px;"
            />
            <span>费用合计</span>
          </el-col>
        </el-row>
        <el-row
          style="height:70px;line-height:70px;text-align:center;color:#6f7075;border-bottom:1px #F1EFF2 solid;"
        >
          <el-col :span="6" class="borderRight">消费总额</el-col>
          <el-col :span="6" class="borderRight">{{totalCost.monetary}}</el-col>
          <el-col :span="6" class="borderRight">退费总额</el-col>
          <el-col :span="6" class="borderRight">{{totalCost.itemsTotal}}</el-col>
        </el-row>
        <el-row style="height:70px;line-height:70px;text-align:center;color:#6f7075;">
          <el-col :span="6" class="borderRight">出院前余额</el-col>
          <el-col :span="6" class="borderRight">{{totalCost.remainder}}</el-col>
          <el-col :span="6" class="borderRight">应缴合计</el-col>
          <el-col :span="6" class="borderRight">{{totalCost.totalPay}}</el-col>
        </el-row>
      </el-row>
      <el-row class="borderMargintop">
        <el-row class="heightBackground">
          <el-col style="font-size:18px;">
            <img
              src="@/assets/beadhouse/juxing.png"
              alt
              style="vertical-align:middle;margin:0 10px;"
            />
            <span>审批状态和原因</span>
          </el-col>
        </el-row>
        <!-- 审批未通过this.approveStateAndReason.stateNum==4 显示审批状态和原因 -->
        <el-row v-if="this.approveStateAndReason.stateNum==4" style="height:70px;line-height:70px;text-align:center;color:#6f7075;">
          <el-col :span="6" class="borderRight">审批状态</el-col>
          <el-col :span="6" class="borderRight">{{approveStateAndReason.state}}</el-col>
          <el-col :span="6" class="borderRight">原因</el-col>
          <el-col :span="6" class="borderRight">{{approveStateAndReason.remark}}</el-col>
        </el-row>
        <!-- 其他状态只显示审批状态 -->
        <el-row v-else style="height:70px;line-height:70px;text-align:center;color:#6f7075;">
          <el-col :span="12" class="borderRight">审批状态</el-col>
          <el-col :span="12" class="borderRight">{{approveStateAndReason.state}}</el-col>
        </el-row>
      </el-row>
    </el-row>
    <el-row style="padding:30px 0;background-color:#fff">
      <div align="center">
        <el-button v-if="isPay === 0 && approveStateAndReason.stateNum !== 5" :size="size" type="primary" @click.native="confirmOutBill" :loading="confirmLoading">确认出院</el-button>
        <el-button v-if="approveStateAndReason.stateNum !== 5" :size="size" plain type="success" @click.native="recalculateRefund" :loading="recalcLoading">重新计算退费</el-button>
        <el-button :size="size" plain type="warning" @click.native="printInfo">打印</el-button>
      </div>
    </el-row>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "LeaveHospitalDetail",
  components: { KtTable, KtButton },
  data() {
    return {
      leaveHospital: {
  oldmanName: "老人姓名",
  enterName: "请输入姓名",
  search: "查询",
  add: "添加",
  idCard: "身份证号",
  sex: "性别",
  birthday: "生日",
  leaveDate: "出院时间",
  state: "状态",
  operator: "操作",
  addLeaveApply: "添加出院申请",
  fuzzySearchOldman: "模糊搜索老人",
  selectDate: "选择日期",
  leaveReason: "出院原因",
  please: "请选择",
  deathReason: "死亡原因",
  deathDate: "死亡日期",
  itemName: "类别",
  money: "金额",
  remark: "备注",
  titleInfo: "信息提示",
  reason: "原因",
  title: "你确定不通过出院申请吗?",
  back: "返回",
  dischargeNotice: "出院通知单",
  baseInfo: "基本信息",
  inDate: "入院时间"
},//引入 lang 里面的字符串资源
      size: "medium", //按钮的尺
      //基本信息
      basicInformation: {
        oldmanName: "",
        sex: "",
        idCard: "",
        bedNo: "",
        birthday: "",
        inDate: ""
      },
      //出院时间
      leaveTime: {
        leaveDate: "",
        type: ""
      },
      //审批状态和原因
      approveStateAndReason: {
        state: "",
        remark: "",
        stateNum:"",
      },
      //应缴项
      shouldPayList: [],
      //退款项 费用项目
      refundItemList: [],
      //退款项 套餐
      setMealList: [],
      //套餐 退款合计
      setMealTotal: "",
      //天数退费  入院月剩余
      onAdmissionRefund: {
        days: 0,
        totalFee: 0
      },
      //天数退费  请假剩余
      LeaveRestRefund: {
        days: 0,
        totalFee: 0
      },
      //天数退费  本月剩余
      thisMonthRestRefund: {
        days: 0,
        totalFee: 0
      },
      //费用合计
      totalCost: {
        monetary: 0, //消费总额
        itemsTotal: 0, //退费总额
        remainder: 0, //出院前余额
        totalPay: 0 //应缴合计
      },
      fromPath:"",
      oldOutId: null,
      isPay: -1,
      confirmLoading: false,
      recalcLoading: false,
    };
  },
  methods: {
    /* 
      返回
    */
    recalculateRefund() {
      if (!this.oldOutId) {
        this.$message({ message: '无法获取出院申请ID', type: 'warning' });
        return;
      }
      this.recalcLoading = true;
      this.$postJson('omc/oldOut/recalculateRefund', { oldOutId: this.oldOutId })
        .then(res => {
          if (res.code == 200 && res.result) {
            this.$message({ message: '退费重算成功', type: 'success' });
            this.queryById(this.oldOutId);
          } else {
            this.$message({ message: res.message || '退费重算失败', type: 'error' });
          }
        })
        .catch(() => { this.$message({ message: '退费重算请求失败', type: 'error' }); })
        .finally(() => { this.recalcLoading = false; });
    },

    handleBack() {
      var leaveHospitalType = sessionStorage.getItem("leaveHospitalType");
      console.log(leaveHospitalType);
      //判断是从哪一个页面跳过来的  一.出院申请--leaveHospitalType=1  出院申请审批---leaveHospitalType=2
      if (leaveHospitalType == 1) {
        sessionStorage.removeItem("leaveHospitalType"); //清除leaveHospitalType
        bus.$emit("close_current_tags");
      } else if (leaveHospitalType == 2) {
          sessionStorage.removeItem("leaveHospitalType"); //清除leaveHospitalType
          sessionStorage.removeItem('leaveHospitalFromPath');
          bus.$emit("close_current_tags");
      }
    },

    /* 
      查询老人出院详情
    */
    queryById(id) {
      this.$postForm("omc/oldOut/queryById/" + id).then(res => {
        console.log(res);
        if (res.code == 200) {
          //基本信息
          this.basicInformation.oldmanName = res.result.oldmanName;
          this.basicInformation.sex = res.result.sex == 0 ? "男" : "女";
          this.basicInformation.idCard = res.result.idCard;
          this.basicInformation.bedNo = res.result.bedNo;
          this.basicInformation.birthday = res.result.birthday;
          this.basicInformation.inDate = res.result.inDate;

          //出院时间
          this.leaveTime.leaveDate = res.result.leaveDate;
          switch (res.result.type) {
            case 1:
              this.leaveTime.type = "试住不适应";
              break;
            case 2:
              this.leaveTime.type = "正常出院";
              break;
            case 3:
              this.leaveTime.type = "院内死亡";
              break;
            default:
              this.leaveTime.type = "院外死亡";
          }

          //重置列表，防止多次调用累加
          this.shouldPayList = [];
          this.refundItemList = [];
          this.setMealList = [];

          //出院的缴退费的集合
          var assessment = 0; //缴费合计
          var returnPremium = 0; //退费合计
          res.result.oldOutItemVoList.forEach(item => {
            console.log(item);
            //adjustOrder    0-入院退款 1-出院应缴项 2-出院退款项'  把应缴项和退款项分开
            let paramsObj = new Object();
            paramsObj.itemName = item.itemName;
            paramsObj.totalFee = item.totalFee;
            if (item.adjustOrder == 1) {
              assessment += item.totalFee * 1;
              this.shouldPayList.push(paramsObj);
            } else {
              returnPremium += item.totalFee * 1;
              this.refundItemList.push(paramsObj);
            }
          });
          if(this.shouldPayList.length>0){
            this.shouldPayList.push({
              itemName: "缴费合计",
              totalFee: assessment
            });
          }
          this.refundItemList.push({
            itemName: "退费合计",
            totalFee: returnPremium
          });
          console.log(
            this.shouldPayList,
            this.refundItemList,
            "应缴项和退款项"
          );

          //退费 套餐集合
          res.result.oldOutSetMealVoList.forEach(item => {
            item.oldOutSetMealItemVoList.forEach(temp => {
              console.log(temp);
              var setMealObj = new Object();
              setMealObj.setMealName = item.setMealName;//套餐名称
              setMealObj.itemName = temp.itemName;//套餐项目
              setMealObj.times = temp.times;//执行频次
              setMealObj.residueDegree = temp.residueDegree;//剩余周期数
              setMealObj.returnStandard = temp.returnStandard;//每一项的退费标准
              setMealObj.itemTotalFee = temp.itemTotalFee;//每一项套餐的费用
              this.setMealList.push(setMealObj);
            });
          });
          //套餐退费合计
          this.setMealTotal = res.result.setMealTotal;
          console.log(this.setMealList, "退费套餐的");

          //天数退费
          res.result.oldOutDaysVoList.forEach(item => {
            console.log(item);
            //类型type  0-入院月剩余天数 1-请假天数 2-本月剩余天数',
            switch (item.type) {
              case 0:
                this.onAdmissionRefund.days = item.days;
                this.onAdmissionRefund.totalFee = item.totalFee;
                break;
              case 1:
                this.LeaveRestRefund.days = item.days;
                this.LeaveRestRefund.totalFee = item.totalFee;
                break;
              case 2:
                this.thisMonthRestRefund.days = item.days;
                this.thisMonthRestRefund.totalFee = item.totalFee;
                break;
            }
          });

          //费用合计
          this.totalCost.monetary = res.result.monetary;
          this.totalCost.itemsTotal = res.result.itemsTotal;
          this.totalCost.remainder = res.result.remainder;
          this.totalCost.totalPay = res.result.totalPay;

          //缴费状态
          this.isPay = res.result.isPay != null ? res.result.isPay : -1;
          //审批状态和原因
          this.approveStateAndReason.stateNum=res.result.state;
          switch (res.result.state) {
            case 1:
              this.approveStateAndReason.state = "未提交";
              break;
            case 2:
              this.approveStateAndReason.state = "申请中";
              break;
            case 3:
              this.approveStateAndReason.state = "接待室审核通过";
              break;
            case 4:
              this.approveStateAndReason.state = "审核未通过";
              break;
            case 5:
              this.approveStateAndReason.state = "收费室确认";
              break;
            case 6:
              this.approveStateAndReason.state = "服务部确认";
              break;
            case 7:
              this.approveStateAndReason.state = "医疗部审核通过";
              break;
          }
        }
        this.queryCommentById(id);
      });
    },

    /* 
      查询审批不通过的原因
    */
    queryCommentById(id){
      this.$postForm('omc/oldOut/queryCommentById/'+id).then(res=>{
        console.log(res,this.approveStateAndReason.state);
        if(this.approveStateAndReason.stateNum == 4){
          console.log(res.result.length-1);
          this.approveStateAndReason.remark = res.result[res.result.length-1].message;
        } 
      })
    },

    /* 
      确认出院缴费单
    */
    confirmOutBill() {
      this.$confirm("确认出院后将解绑床位并完成出院流程，是否继续？", "确认出院", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.confirmLoading = true;
        this.$postForm("omc/oldOut/confirmOutBill/" + this.oldOutId).then(res => {
          if (res.code == 200) {
            this.$message({ message: "出院确认成功", type: "success" });
            this.isPay = 1;
            this.approveStateAndReason.stateNum = 5;
            this.approveStateAndReason.state = "收费室确认";
          } else {
            this.$message({ message: res.message || "确认失败", type: "error" });
          }
          this.confirmLoading = false;
        }).catch(() => {
          this.confirmLoading = false;
        });
      }).catch(() => {});
    },
    /* 
      打印
    */
    printInfo() {
      this.$print(this.$refs.print);
    },
    resetData() {
      this.basicInformation = { oldmanName: "", sex: "", idCard: "", bedNo: "", birthday: "", inDate: "" };
      this.leaveTime = { leaveDate: "", type: "" };
      this.approveStateAndReason = { state: "", remark: "", stateNum: "" };
      this.shouldPayList = [];
      this.refundItemList = [];
      this.setMealList = [];
      this.setMealTotal = "";
      this.onAdmissionRefund = { days: 0, totalFee: 0 };
      this.LeaveRestRefund = { days: 0, totalFee: 0 };
      this.thisMonthRestRefund = { days: 0, totalFee: 0 };
      this.totalCost = { monetary: 0, itemsTotal: 0, remainder: 0, totalPay: 0 };
      this.isPay = -1;
      this.oldOutId = null;
    },
  },
  created() {},
  activated() {
    const pending = sessionStorage.getItem("pendingOutId");
    if (pending && pending !== "undefined" && pending !== "null") {
      sessionStorage.removeItem("pendingOutId");
      this.resetData();
      this.oldOutId = pending;
      this.queryById(pending);
    }
  },
  mounted() {
    console.log(this.$route.query.oldOutRow, "===============");
    let oldOutRow = this.$route.query.oldOutRow;
    let id = (oldOutRow && typeof oldOutRow === 'object' && oldOutRow.id) ? oldOutRow.id : null;
    if (!id || id === 'undefined') {
      const pending = sessionStorage.getItem("pendingOutId");
      if (pending && pending !== 'undefined' && pending !== 'null') {
        id = pending;
      }
    }
    sessionStorage.removeItem("pendingOutId");
    if (!id || id === 'undefined' || id === 'null') {
      console.warn("LeaveHospitalDetail: 缺少出院记录ID，跳过加载");
      return;
    }
    this.oldOutId = id;
    console.log(id);
    this.queryById(id);
    //通知主界面缓存该界面
    // 延迟1秒添加到 主界面通知存储到keep-alive列表中;目的是为了在主界面清除keep-alive,跳转后显示的是初始数据,然后过一秒后再存储起来,
    setTimeout(function() {
      bus.$emit("homePage", { type: "add", path: "/LeaveHospitalDetail" });
    }, "1000");

    this.fromPath=sessionStorage.getItem("leaveHospitalFromPath");
    console.log(this.fromPath,"this.fromPath");
  }
};
</script>
<style lang="scss" scoped>
.leavehospitaldetail {
  width: 100%;
  height: 100%;
  background: #fff;
}
.marginTop25{
  margin-top:5px;
  margin-bottom:2px;
}
.borderMargintop{
  border: 1px #e2e2e2 solid;
  margin-top:30px;
}
.heightBackground{
  height:54px;
  line-height:54px;
  background:#fff;
  border:1px #F1EFF2 solid;
}
.borderRight{
  border-right:1px #F1EFF2 solid;
  background-color:#fff;
}
tr{
  background-color:#fff;
}
.height40{
  height:40px;
  line-height: 32px;
}
.table {
  width: 100%;
  margin: 0px auto;
  border-collapse: collapse;
  border: 1px solid #F1EFF2;
  color:#6f7075;

}
.tr {
  height:70px;
  line-height:70px;
  text-align: center;
}
.th1{
  border:1px solid #F1EFF2;
  width:50%;
  background-color:#fff;
  font-weight:700;
}
.td1{
  border:1px solid #F1EFF2;
  width:50%;
}
.th2{
  border:1px solid #F1EFF2;
  width:20%;
  background-color:#fff;
  font-weight:700;
}
.td2{
  border:1px solid #F1EFF2;
  width:20%;
}
</style>
